module.exports = __webpack_public_path__ + "img/Carousel_5.5a1b3ad8.jpg";